import { useEffect } from "react";

import { useUserProfileContext } from "@/contexts/UserProfileContext";
import { MIGRATE_AFFILIATE_TO_PRACTITIONER_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";

import Common from "./ui/CommonForm";

export default function AffiliateApplyingToBePractitionerForm({
  setFormSubmitted,
  affiliateProfile
}) {
  const { patientProfile } = useUserProfileContext();

  const api = useDjangoGraphqlForm({
    transformer: input => ({
      ...input,
      professionalBodies: input.professionalBodies.join(","),
      documents: JSON.stringify(
        input.documents.reduce((acc, doc) => {
          if (doc.type in acc) {
            return {
              ...acc,
              [doc.type]: [
                ...acc[doc.type],
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          } else {
            return {
              ...acc,
              [doc.type]: [
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          }
        }, {})
      )
    }),
    mutation: MIGRATE_AFFILIATE_TO_PRACTITIONER_MUTATION,
    mutationName: "migrateAffiliateToPractitionerMutation",
    defaultValues: {
      firstName: patientProfile?.user?.firstName || "",
      lastName: patientProfile?.user?.lastName || "",
      email: patientProfile?.user?.email || "",
      dateOfBirth: patientProfile?.dateOfBirth || "",
      gender: patientProfile?.gender || "",
      practitionerType: "",
      professionalBodies: [],
      documents: [],
      phoneNumber: affiliateProfile.phoneNumber || "",
      jobRole: affiliateProfile.jobRole || "",
      businessName: "",
      specialisms: [],
      businessLocationCity: affiliateProfile.businessLocationCity || "",
      businessCountry: "",
      instagram: affiliateProfile.instagram || "",
      linkedin: affiliateProfile.linkedin || "",
      youtube: affiliateProfile.youtube || "",
      websiteBlog: affiliateProfile.websiteBlog || "",
      acceptTerms: false
    },
    handleSuccess: () => {
      setFormSubmitted(true);
    }
  });

  useEffect(() => {
    if (patientProfile) {
      api.methods.reset({
        firstName: patientProfile?.user?.firstName || "",
        lastName: patientProfile?.user?.lastName || "",
        email: patientProfile?.user?.email || "",
        dateOfBirth: patientProfile?.dateOfBirth || "",
        gender: patientProfile?.gender || "",
        practitionerType: "",
        professionalBodies: [],
        documents: [],
        phoneNumber: affiliateProfile.phoneNumber || "",
        jobRole: affiliateProfile.jobRole || "",
        businessLocationCity: affiliateProfile.businessLocationCity || "",
        businessCountry: "",
        businessName: "",
        specialisms: [],
        acceptTerms: false
      });
    }
  }, [patientProfile]);

  return (
    <Common
      api={api}
      readOnlyFields={["firstName", "lastName", "email", "gender", "dateOfBirth"]}
    />
  );
}
